/* eslint-disable no-unused-vars */
'use-strict';

var utils = require('pagedesigner/util/utils');

var carouselResources = window.carouselResources || {};

// Custom Arrows for slick carousels
var prevLabel = carouselResources.prev || 'Previous';
var nextLabel = carouselResources.next || 'Next';
var prevArrow = `<button class='slick-prev slick-arrow' type='button' aria-label='${prevLabel}'><span class='sr-only'>${prevLabel}</span></button>`;
var nextArrow = `<button class='slick-next slick-arrow' type='button' aria-label='${nextLabel}'><span class='sr-only'>${nextLabel}</span></button>`;
var customPaging = function (_slider, i) {
    var slideLabel = carouselResources.slideLabel || 'Carousel slide';
    if (slideLabel.indexOf('{0}') !== -1) {
        slideLabel = slideLabel.replace('{0}', i + 1);
    } else {
        slideLabel = slideLabel + ' ' + (i + 1);
    }
    return `<button type='button' aria-label='${slideLabel}'></button>`;
};

var SLICK_SETTINGS = {
    module1: {
        slidesToShow: 1,
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },
    module2: {
        slidesToShow: 1,
        infinite: false,
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },
    module5: {
        mobile: {
            slidesToShow: 2,
            infinite: false,
            customPaging: customPaging,
            prevArrow: prevArrow,
            nextArrow: nextArrow
        },
        desktop: {
            slidesToShow: 3,
            infinite: false,
            customPaging: customPaging,
            prevArrow: prevArrow,
            nextArrow: nextArrow
        }
    },
    module7: {
        slidesToShow: 1,
        infinite: true,
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },
    module10: {
        mobile: {
            infinite: false,
            slidesToShow: 1.3,
            slidesToScroll: 1,
            customPaging: customPaging,
            prevArrow: prevArrow,
            nextArrow: nextArrow
        },
        desktop: {
            infinite: false,
            slidesToShow: 2,
            customPaging: customPaging,
            prevArrow: prevArrow,
            nextArrow: nextArrow
        }
    },
    module10B: {
        slidesToShow: 1,
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },
    module12: {
        mobile: {
            infinite: false,
            slidesToShow: 2,
            customPaging: customPaging,
            prevArrow: prevArrow,
            nextArrow: nextArrow
        },
        desktop: {
            infinite: false,
            slidesToShow: 4,
            customPaging: customPaging,
            prevArrow: prevArrow,
            nextArrow: nextArrow
        }
    },
    module15: {
        slidesToShow: 1,
        infinite: true,
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },
    module16: {
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },
    module17: {
        infinite: false,
        slidesToShow: 4,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1.3
                }
            }
        ],
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },
    module18: {
        slidesToShow: 1,
        infinite: true,
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },
    moduleMayWeSuggest: {
        dots: true,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ],
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    }
};

/**
 * Apply autoplay settings if possible
 * @param {jQuery} $module - current module entity
 * @param {Object} slickConfig - config for current module
 * @return {Object} - updated slickConfig
 */
function appendAutoplaySettings($module, slickConfig) {
    var autoPlayInput = $module.find('.carousel-autoplay');
    var autoPlayInputMobile = $module.find('.carousel-autoplay-mobile');
    var autoPlayInputDesktop = $module.find('.carousel-autoplay-desktop');
    var hasAutoplay = autoPlayInput.length > 0;
    var hasAutoplayResponsive = autoPlayInputMobile.length > 0 && autoPlayInputDesktop.length > 0;
    var config = slickConfig;
    if (hasAutoplay) {
        config = $.extend(true, { autoplay: true, autoplaySpeed: autoPlayInput.val() }, slickConfig);
    }
    if (hasAutoplayResponsive) {
        config = $.extend(true, { autoplay: true, autoplaySpeed: autoPlayInputDesktop.val(), responsive: [{ breakpoint: 992, settings: { autoplay: true, autoplaySpeed: autoPlayInputMobile.val() } }] }, slickConfig);
    }
    return config;
}

/**
 * Apply animation speed setting if possible
 * @param {*} $module - current module entity
 * @param {*} slickConfig - config for current module
 * @return {Object} - updated slickConfig
 */
function appendSpeedSettings($module, slickConfig) {
    var speedInput = $module.find('.carousel-speed');
    var hasSpeed = speedInput.length > 0;
    var config = slickConfig;
    if (hasSpeed) {
        config = $.extend(true, { speed: speedInput.val() }, slickConfig);
    }
    return config;
}

/**
 * Apply 4 Slides to Scroll
 * @param {jQuery} $module - current module entity
 * @param {Object} slickConfig - config for current module
 * @return {Object} - updated slickConfig
 */
function appendScrollRow($module, slickConfig) {
    var showScrollRow2 = $module.find('.carousel-twoSlides');
    var showScrollRow4 = $module.find('.carousel-fourSlides');
    var hasShowScrollRow2 = showScrollRow2.length > 0;
    var hasShowScrollRow4 = showScrollRow4.length > 0;
    var config = slickConfig;
    if (hasShowScrollRow2) {
        config = $.extend(true, { slidesToScroll: 2 }, slickConfig);
    }
    if (hasShowScrollRow4) {
        config = $.extend(true, { slidesToScroll: 4 }, slickConfig);
    }
    return config;
}

/**
 * Stop Infinite Loop
 * @param {jQuery} $module - current module entity
 * @param {Object} slickConfig - config for current module
 * @return {Object} - updated slickConfig
 */
function stopInfiniteLoop($module, slickConfig) {
    var showCarouselInfinite = $module.find('.carousel-infinite');
    var hasShowCarouselInfinite = showCarouselInfinite.length > 0;
    var config = slickConfig;
    if (hasShowCarouselInfinite) {
        config.infinite = false;
    }
    return config;
}

/**
 * Toggle Arrows on Carousels/Sliders
 * @param {jQuery} $module - current module entity
 * @param {Object} slickConfig - config for current module
 * @return {Object} - updated slickConfig
 */
function appendToggleArrow($module, slickConfig) {
    var toggleArrowOnDesktop = $module.find('.carousel-arrowOnDesktop');
    var toggleArrowOnMobile = $module.find('.carousel-arrowOnMobile');
    var hastoggleArrowOnDesktop = toggleArrowOnDesktop.length > 0;
    var hastoggleArrowOnMobile = toggleArrowOnMobile.length > 0;
    var config = slickConfig;
    if (hastoggleArrowOnDesktop) {
        config = $.extend(true, { arrows: toggleArrowOnDesktop.val(), responsive: [{ breakpoint: 992, settings: { arrows: true } }] }, slickConfig);
    }
    if (hastoggleArrowOnMobile) {
        config = $.extend(true, { responsive: [{ breakpoint: 992, settings: { arrows: toggleArrowOnMobile.val() } }] }, slickConfig);
    }
    if (hastoggleArrowOnDesktop && hastoggleArrowOnMobile) {
        config = $.extend(true, { arrows: false, responsive: [{ breakpoint: 992, settings: { arrows: false } }] }, slickConfig);
    }
    return config;
}

/**
 * Toggle Arrows on Carousels/Sliders
 * @param {jQuery} $module - current module entity
 * @param {Object} slickConfig - config for current module
 * @return {Object} - updated slickConfig
 */
function appendPagination($module, slickConfig) {
    var paginationDesktop = $module.find($('.carousel-paginationDesktop'));
    var paginationMobile = $module.find($('.carousel-paginationMobile'));
    var config = slickConfig;
    config = $.extend(true, { dots: paginationDesktop.val() === 'true', responsive: [{ breakpoint: 992, settings: { dots: paginationMobile.val() === 'true' } }] }, slickConfig);

    return config;
}

/**
 * Apply Instant Switch settings if possible
 * @param {jQuery} $module - current module entity
 * @param {Object} slickConfig - config for current module
 * @return {Object} - updated slickConfig
 */
function appendInstantSwitch($module, slickConfig) {
    var instantSwitch = $module.find('.carousel-switch');
    var hasInstantSwitch = instantSwitch.length > 0;
    var config = slickConfig;
    if (hasInstantSwitch) {
        config = $.extend(true, { fade: true, speed: instantSwitch.val() }, slickConfig);
    }
    return config;
}

/**
 * Apply Slider Pause settings
 * @param {jQuery} $module - current module entity
 * @param {Object} slickConfig - config for current module
 * @return {Object} - updated slickConfig
 */
function appendPauseOnHover($module, slickConfig) {
    var pauseOnHover = $module.find('.carousel-pauseOnHover');
    var hasPauseOnHover = pauseOnHover.length > 0;
    var config = slickConfig;
    if (hasPauseOnHover) {
        config = $.extend(true, { pauseOnHover: false }, slickConfig);
    }
    return config;
}

/**
 * Group module 16 tiles for mobile
 */
function groupModule16Tiles() {
    if ($('.mobile-module-16-slide').length === 0) {
        $('.experience-modules_layouts-module16Layout').each(function (index, elem) {
            var length = $(elem).find('.experience-modules_assets-module6Tile').length;
            var slidesToShow = $(elem).find('.mobile-preview').length !== 0 ? 1 : 1.2;
            var infiniteLoop = slidesToShow === 1;

            var groupsCount = Math.ceil(length / 6);
            var groups = [];
            for (var i = 1; i <= groupsCount; i++) {
                groups.push($('.experience-modules_layouts-module16Layout .experience-tiles_16 > .experience-modules_assets-module6Tile').filter(function (index) { // eslint-disable-line
                    return index + 1 <= i * 6 && index + 1 > (i * 6) - 6;
                }));
            }

            groups.forEach(function (element) {
                element.wrapAll('<div class="mobile-module-16-slide"></div>');
            });

            if (length > 6) {
                var slickConfig = SLICK_SETTINGS.module16;
                slickConfig = $.extend(true, { slidesToShow: slidesToShow }, slickConfig);
                slickConfig = $.extend(true, { infinite: infiniteLoop }, slickConfig);
                slickConfig = appendSpeedSettings($(elem), slickConfig);
                slickConfig = appendAutoplaySettings($(elem), slickConfig);
                slickConfig = appendToggleArrow($(this), slickConfig);
                $(elem).find('.experience-tiles_16').slick(slickConfig);
            }
        });
    }
}

/**
 * Ungroup module 16 tiles for desktop
 */
function unGroupModule16Tiles() {
    if ($('.mobile-module-16-slide').length > 0) {
        if ($('.experience-modules_layouts-module16Layout .experience-tiles_16').hasClass('slick-initialized')) {
            $('.experience-modules_layouts-module16Layout .experience-tiles_16').slick('unslick');
        }

        $('.mobile-module-16-slide').each(function (index, elem) {
            $(elem).children().appendTo($(elem).parent());
            $(elem).remove();
        });
    }
}

/**
 * Build Mobile tiles for module 5
 */
function buildMobileModule5View() {
    $('.experience-modules_layouts-module5Layout').each(function (index, elem) {
        if ($(elem).find('.experience-tiles_5').hasClass('slick-initialized')) {
            $(elem).find('.experience-tiles_5').slick('unslick');
        }

        if (!$(elem).hasClass('mobile-module-5-view')) {
            $(elem).addClass('mobile-module-5-view');
            var firstModuleTile = $(elem).find('.experience-modules_assets-moduleTile, .experience-modules_assets-module5Tile').first();
            $(elem).find('.module5Layout_innerDiv').prepend(firstModuleTile);
        }

        if ($(elem).find('.experience-tiles_5').hasClass('carousel-active')) {
            var slickConfig = SLICK_SETTINGS.module5.mobile;
            slickConfig = appendAutoplaySettings($(elem), slickConfig);
            slickConfig = appendToggleArrow($(this), slickConfig);
            slickConfig = appendPauseOnHover($(this), slickConfig);
            $(elem).find('.experience-tiles_5').slick(slickConfig);
        }
    });
}

/**
 * Build Desktop tiles for module 5
 */
function buildDesktopModule5View() {
    $('.experience-modules_layouts-module5Layout').each(function (index, elem) {
        if ($(elem).find('.experience-tiles_5').hasClass('slick-initialized')) {
            $(elem).find('.experience-tiles_5').slick('unslick');
        }

        if ($(elem).hasClass('mobile-module-5-view')) {
            $(elem).removeClass('mobile-module-5-view');
            var firstModuleTile = $(elem).find('.experience-modules_assets-moduleTile, .experience-modules_assets-module5Tile').first();
            $(elem).find('.experience-tiles_5').prepend(firstModuleTile);
        }

        if ($(elem).find('.experience-tiles_5').hasClass('carousel-active')) {
            var slickConfig = SLICK_SETTINGS.module5.desktop;
            slickConfig = appendAutoplaySettings($(elem), slickConfig);
            slickConfig = appendSpeedSettings($(elem), slickConfig);
            slickConfig = appendToggleArrow($(this), slickConfig);
            $(elem).find('.experience-tiles_5').slick(slickConfig);
        }
    });
}

/**
 * Module 10 Mobile Carousel
 */
function mobileCarouselModule10() {
    $('.experience-modules_layouts-module10Layout').each(function (index, elem) {
        if ($(elem).find('.experience-tileCarousel_10').hasClass('slick-initialized')) {
            $(elem).find('.experience-tileCarousel_10').slick('unslick');
        }

        var tilesLength = $(elem).children().length;
        if (tilesLength >= 2) {
            var slickConfig = SLICK_SETTINGS.module10.mobile;
            var toggleArrows = $(elem).find('.carousel-arrowOnMobile');
            slickConfig = $.extend(true, { arrows: toggleArrows.val() }, slickConfig);
            slickConfig = appendAutoplaySettings($(this), slickConfig);
            slickConfig = appendSpeedSettings($(this), slickConfig);
            $(elem).find('.experience-tileCarousel_10').slick(slickConfig);
        }
    });
}

/**
 * Module 12 Mobile Carousel
 */
function mobileCarouselModule12() {
    $('.experience-modules_layouts-module12Layout').each(function (index, elem) {
        if ($(elem).find('.experience-tiles_12').hasClass('slick-initialized')) {
            $(elem).find('.experience-tiles_12').slick('unslick');
        }

        // var tilesLength = $(elem).children().length;
        var slickConfig = SLICK_SETTINGS.module12.mobile;
        slickConfig = appendAutoplaySettings($(this), slickConfig);
        // slickConfig = appendScrollRow($(this), slickConfig);
        var slidesToScroll = $(elem).find('.carousel-fourSlides').length > 0 ? 2 : 1;
        slickConfig = $.extend(true, { slidesToScroll: slidesToScroll }, slickConfig);
        slickConfig = appendSpeedSettings($(this), slickConfig);
        slickConfig = appendToggleArrow($(this), slickConfig);
        slickConfig = appendPauseOnHover($(this), slickConfig);
        $(this).find('.experience-tiles_12').slick(slickConfig);
    });
}

/**
 * Module 10 Desktop Carousel
 */
function desktopCarouselModule10() {
    $('.experience-modules_layouts-module10Layout').each(function (index, elem) {
        if ($(elem).find('.experience-tileCarousel_10').hasClass('slick-initialized')) {
            $(elem).find('.experience-tileCarousel_10').slick('unslick');
        }

        if ($(elem).find('.experience-tileCarousel_10').hasClass('carousel-active')) {
            var slickConfig = SLICK_SETTINGS.module10.desktop;
            var slidesToScroll = $(elem).find('.carousel-twoSlides').length > 0 ? 2 : 1;
            var toggleArrows = $(elem).find('.carousel-arrowOnDesktop');
            slickConfig = $.extend(true, { arrows: toggleArrows.val() }, slickConfig);
            slickConfig = $.extend(true, { slidesToScroll: slidesToScroll }, slickConfig);
            slickConfig = appendAutoplaySettings($(this), slickConfig);
            slickConfig = appendSpeedSettings($(this), slickConfig);
            $(elem).find('.experience-tileCarousel_10').slick(slickConfig);
        }
    });
}

/**
 * Module 12 Desktop Carousel
 */
function desktopCarouselModule12() {
    $('.experience-modules_layouts-module12Layout').each(function (index, elem) {
        if ($(elem).find('.experience-tiles_12').hasClass('slick-initialized')) {
            $(elem).find('.experience-tiles_12').slick('unslick');
        }
        var slickConfig = SLICK_SETTINGS.module12.desktop;
        slickConfig = appendAutoplaySettings($(this), slickConfig);
        slickConfig = appendScrollRow($(this), slickConfig);
        slickConfig = appendSpeedSettings($(this), slickConfig);
        slickConfig = appendToggleArrow($(this), slickConfig);
        $(this).find('.experience-tiles_12').slick(slickConfig);
    });
}

/**
 * TCatAB Carousels Mobile
 */
function mobileCarouselTCatAB() {
    $('.experience-modules_layouts-categoryBrowseAB .experience-tileCarousel_AB').each(function (index, elem) {
        if ($(elem).hasClass('slick-initialized')) {
            $(elem).slick('unslick');
        }

        var categoryAutoPlay = $(this).parent().find($('.carousel-autoplay-mobile'));
        var categorySpeed = $(this).parent().find($('.carousel-speed'));
        var noMobilePreview = $(this).parent().find($('.mobile-preview'));
        var mobileSlidesToShow = noMobilePreview.length > 0 ? 1 : $(this).data('slides-mobile');
        var noArrowMob = $(this).parent().find($('.carousel-arrowOnMobile'));
        var slidesToScrollMobile = Math.round($(this).data('slides-scrollmobile'));

        var categoryBrowseSlidesToShow = $(this).data('slides-mobile');
        var slideAbRow = $(this).parent().find('.carousel-slideRow');
        var slideInfinite = (() => {
            var i = false;
            if ((slideAbRow.length > 0 && categoryBrowseSlidesToShow % 1 === 0) || categoryAutoPlay.length > 0) {
                i = true;
            }
            return i;
        })();

        var paginationMobile = $(this).parent().find($('.carousel-paginationMobile'));
        var carouselPagination;
        if (paginationMobile.val() === 'true') {
            carouselPagination = true;
        } else {
            carouselPagination = false;
        }

        var pauseOnHoverInput = $(this).parent().find($('.carousel-pauseOnHover'));
        var slickConfig = {
            infinite: slideInfinite,
            dots: carouselPagination,
            autoplay: categoryAutoPlay.length > 0,
            autoplaySpeed: categoryAutoPlay.length > 0 ? categoryAutoPlay.val() : 2000,
            speed: categorySpeed.length > 0 ? categorySpeed.val() : 300,
            slidesToShow: mobileSlidesToShow,
            slidesToScroll: slidesToScrollMobile,
            arrows: noArrowMob.length > 0 ? noArrowMob.val() : true,
            customPaging: customPaging
        };
        if (pauseOnHoverInput.length > 0) {
            slickConfig.pauseOnHover = false;
        }
        $(elem).slick(slickConfig);
    });
}

/**
 * TCatAB Carousels Desktop
 */
function desktopCarouselTCatAB() {
    $('.experience-modules_layouts-categoryBrowseAB .experience-tileCarousel_AB').each(function (index, elem) {
        if ($(elem).hasClass('slick-initialized')) {
            $(elem).slick('unslick');
        }

        var tilesLength = $(elem).children().length;
        var categoryBrowseSlidesToShow = $(this).data('slides-desktop');

        if (tilesLength > categoryBrowseSlidesToShow) {
            var categoryAutoPlay = $(this).parent().find($('.carousel-autoplay-desktop'));
            var categorySpeed = $(this).parent().find($('.carousel-speed'));
            var noArrowDesk = $(this).parent().find($('.carousel-arrowOnDesktop'));
            var slideAbRow = $(this).parent().find('.carousel-slideRow');
            var paginationDesktop = $(this).parent().find($('.carousel-paginationDesktop'));
            var carouselPagination;
            if (paginationDesktop.val() === 'true') {
                carouselPagination = true;
            } else {
                carouselPagination = false;
            }

            var slideInfinite = (()=>{
                var i = false;
                if ((slideAbRow.length > 0 && categoryBrowseSlidesToShow % 1 === 0) || categoryAutoPlay.length > 0) {
                    i = true;
                }
                return i;
            })();
            var pauseOnHoverInput = $(this).parent().find($('.carousel-pauseOnHover'));
            var slickConfig = {
                infinite: slideInfinite,
                dots: carouselPagination,
                slidesToShow: categoryBrowseSlidesToShow,
                slidesToScroll: slideAbRow.length > 0 ? Math.floor(categoryBrowseSlidesToShow) : 1,
                autoplay: categoryAutoPlay.length > 0,
                autoplaySpeed: categoryAutoPlay.length > 0 ? categoryAutoPlay.val() : 2000,
                speed: categorySpeed.length > 0 ? categorySpeed.val() : 300,
                arrows: noArrowDesk.length > 0 ? noArrowDesk.val() : true,
                customPaging: customPaging
            };
            if (pauseOnHoverInput.length > 0) {
                slickConfig.pauseOnHover = false;
            }
            $(elem).slick(slickConfig);
        }
    });
}

/**
 * TCatDE Carousels Mobile
 */
function mobileCarouselTCatDE() {
    $('.experience-modules_layouts-categoryBrowseDE .experience-tileCarousel_DE').each(function (index, elem) {
        if ($(elem).hasClass('slick-initialized')) {
            $(elem).slick('unslick');
        }

        var noArrowMob = $(elem).parent().find('.carousel-arrowOnMobile');

        $(elem).slick({
            infinite: false,
            slidesToShow: 2.5,
            slidesToScroll: 1,
            arrows: noArrowMob.length > 0 ? noArrowMob.val() : true
        });
    });
}

/**
 * TCatDE Carousels Desktop
 */
function desktopCarouselTCatDE() {
    $('.experience-modules_layouts-categoryBrowseDE .experience-tileCarousel_DE').each(function (index, elem) {
        if ($(elem).hasClass('slick-initialized')) {
            $(elem).slick('unslick');
        }

        var tilesLength = $(elem).children().length;
        if (tilesLength > 6) {
            var slideDeRow = $(elem).parent().find('.carousel-slideRow');
            var noArrowDesk = $(elem).parent().find('.carousel-arrowOnDesktop');
            var deSlidesToShow = slideDeRow.length > 0 ? 6 : 1;

            $(elem).slick({
                infinite: !slideDeRow.length > 0,
                slidesToShow: 6,
                slidesToScroll: deSlidesToShow,
                arrows: noArrowDesk.length > 0 ? noArrowDesk.val() : true
            });
        }
    });
}

/**
 * Active stage for tile with same href as window url
 * @param {*} elem - carousel parent element
 * @param {*} num - slides to show
 * @return {Integer} - active tile index
 */
function activeTileCarouselE(elem, num) {
    // Normalize URL by removing analytics parameters to reduce string comparison length
    var fullPath = window.location.pathname + window.location.search;
    var pathName = fullPath.split(/[?&](icid|ecid)=/)[0];
    var tiles = elem.children();
    var activeTile = 0;
    var activeTileIndex = 0;
    var found = false;

    tiles.each(function (i, e) {
        // Early exit if active tile already found
        if (found) return true;

        var $tile = $(e);
        var $link = $tile.find('a');

        if ($link.length) {
            var href = $link.attr('data-href') || $link.attr('href');
            // Normalize tile href to strip analytics parameters
            var normalizedHref = href ? href.split(/[?&](icid|ecid)=/)[0] : '';

            if (normalizedHref === pathName && href !== '#') {
                $link.addClass('disabled');
                $tile.find('picture.picture-tile').each(function () {
                    var $sources = $(this).find('source');
                    $sources.each(function () {
                        var $source = $(this);
                        var srcset = $source.attr('srcset');
                        var dataSrc = $source.attr('data-src');

                        if (srcset) {
                            $source.attr('srcset', srcset.replace('_default', '_active'));
                        }
                        if (dataSrc) {
                            $source.attr('data-src', dataSrc.replace('_default', '_active'));
                        }
                    });
                    var imgSrc = $link.find('.img-tile-default').attr('src');
                    if (imgSrc) {
                        $link.find('.img-tile-default').attr('src', imgSrc.replace('_default', '_active'));
                    }
                });

                activeTile = i;
                found = true;
                return false; // Break the loop since we found the active tile
            }
        }
        return true; // Continue to next iteration
    });

    activeTileIndex = (()=>{
        var t = 0; // Default to 0 instead of empty string
        if (utils.mediaBreakpointDown('md')) {
            //  MOBILE
            if ((activeTile + 1) === tiles.length) {
                t = (activeTile - 1);
            } else if ((activeTile + 1) > 2 && (activeTile + 1) < tiles.length) {
                t = activeTile;
            } else if ((activeTile + 1) <= 2) {
                t = 0;
            }
        } else {
            //  DESKTOP
            t = (activeTile + 1) <= Math.round(num) ? 0 : activeTile;
        }
        return t;
    })();

    return activeTileIndex;
}

/**
 * TCat E Carousels Mobile
 */
function mobileCarouselTCatE() {
    $('.experience-tileCarousel_E').each(function () {
        var gridMobileCarousel = $(this).data('slides-gridviewmobile');

        if ($(this).hasClass('slick-initialized')) {
            $(this).slick('unslick');
        }

        if (gridMobileCarousel) {
            activeTileCarouselE($(this), 0);
            $(this).addClass('carousel-mobile-grid');
            var slidesCount = $(this).children('.experience-modules_assets-moduleImageHover').length;

            if (slidesCount > 8) {
                $(this).next('.mobileGridViewBtn-wrapper').removeClass('d-none');
            }
        } else {
            var slidesPagination = $(this).data('slides-paginationmobile');
            var slidesToShowMobile = $(this).data('slides-mobile');
            var slidesToScrollMobile = Math.round($(this).data('slides-scrollmobile'));
            var slidesVariableWidth = $(this).data('slides-variable');
            var arrowsToShowMobile = $(this).data('slides-arrowsmobile');
            var autoplayToShowMobile = $(this).data('slides-autoplaymobile');
            var activeTileIndex = activeTileCarouselE($(this), 0);

            if (!(Math.floor(slidesToShowMobile) === slidesToShowMobile)) {
                slidesToShowMobile = Math.trunc(slidesToShowMobile);
            }
            if (slidesVariableWidth) {
                slidesToShowMobile = 1;
                slidesToScrollMobile = 1;
            }
            var slickConfig = {
                arrows: arrowsToShowMobile,
                infinite: autoplayToShowMobile,
                autoplay: autoplayToShowMobile,
                dots: slidesPagination,
                slidesToShow: slidesToShowMobile,
                slidesToScroll: slidesToScrollMobile,
                variableWidth: slidesVariableWidth,
                customPaging: customPaging
            };

            $(this).slick(slickConfig);
            $(this).slick('slickGoTo', activeTileIndex);
        }
    });
}

/**
 * TCat E Carousels Desktop
 */
function desktopCarouselTCatE() {
    $('.experience-tileCarousel_E').each(function () {
        var slidesToggleCarousel = $(this).data('slides-togglecarousel');
        $(this).removeClass('carousel-mobile-grid');
        if ($(this).hasClass('slick-initialized')) {
            $(this).slick('unslick');
        }

        if (!slidesToggleCarousel) {
            var slidesPagination = $(this).data('slides-paginationdesktop');
            var slidesToShowDesktop = $(this).data('slides-desktop');
            var slidesToScrollDesktop = Math.round($(this).data('slides-scrolldesktop'));
            var slidesVariableWidth = $(this).data('slides-variable');
            var arrowsToShowDesktop = $(this).data('slides-arrowsdesktop');
            var autoplayToShowDesktop = $(this).data('slides-autoplaydesktop');
            var slidesCount = $(this).children('.experience-modules_assets-moduleImageHover').length;

            if (!(Math.floor(slidesToShowDesktop) === slidesToShowDesktop)) {
                slidesToShowDesktop = Math.trunc(slidesToShowDesktop);
            }

            if (slidesVariableWidth) {
                slidesToShowDesktop = 1;
                slidesToScrollDesktop = 1;
            }

            var slickConfig = {
                arrows: arrowsToShowDesktop,
                autoplay: autoplayToShowDesktop,
                dots: slidesPagination,
                slidesToShow: slidesToShowDesktop,
                slidesToScroll: slidesToScrollDesktop,
                variableWidth: slidesVariableWidth,
                customPaging: customPaging
            };

            if (slidesCount === slidesToShowDesktop) {
                $(this).addClass('px-0');
            }

            var activeTileIndex = activeTileCarouselE($(this), slidesToShowDesktop);
            $(this).slick(slickConfig);
            $(this).slick('slickGoTo', activeTileIndex);
        } else {
            activeTileCarouselE($(this), 0);
        }
    });
}

/**
 * 3x3 Images Grid Carousel Mobile
 */
function mobileCarouselImagesGrid() {
    $('.experience-componentImageGrid.carousel-on').each(function (index, elem) {
        if (utils.mediaBreakpointDown('sm')) {
            $(elem).slick({
                arrows: false,
                dots: true,
                infinite: false,
                slidesToShow: 1.12,
                slidesToScroll: 1,
                customPaging: customPaging
            });
        } else if (!utils.mediaBreakpointDown('sm')) {
            if ($(elem).hasClass('slick-initialized')) {
                $(elem).slick('unslick');
            }
        }
    });
}

/**
 * Module Carousel 1-8 Mobile
 */
function mobileCarousel1To8() {
    $('.experience-moduleCarousel1To8 .experience-region').each(function () {
        var $carousel = $(this);
        var $moduleCarousel = $carousel.closest('.experience-moduleCarousel1To8');
        var gridViewMobile = $carousel.attr('data-slides-gridviewmobile') === 'true';

        if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
        }

        if (gridViewMobile) {
            $carousel.addClass('carousel-mobile-grid');
            var gridColumns = parseInt($carousel.attr('data-slides-gridcolumns'), 10) || 4;
            var colWidth = (100 / gridColumns).toFixed(3) + '%';
            $carousel.children('.experience-component').css({ flex: '0 0 ' + colWidth, 'max-width': colWidth });
            var slidesCount = $carousel.children().length;
            if (slidesCount > 8) {
                $carousel.next('.mobileGridViewBtn-wrapper').removeClass('d-none');
            }
        } else {
            var slidesMobileRaw = parseFloat($carousel.attr('data-slides-mobile')) || 1.2;
            var slidesMobile = Math.floor(slidesMobileRaw);
            var slidesScrollMobile = parseInt($carousel.attr('data-slides-scrollmobile'), 10) || 1;
            var paginationMobile = $carousel.attr('data-slides-paginationmobile') === 'true';
            var arrowsMobile = $carousel.attr('data-slides-arrowsmobile') === 'true';
            var autoplayMobile = $carousel.attr('data-slides-autoplaymobile') === 'true';
            var autoplaySpeedMobile = parseInt($carousel.attr('data-autoplay-speed-mobile'), 10) || 2;

            var slickConfig = {
                dots: paginationMobile,
                arrows: arrowsMobile,
                prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span></button>',
                nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span></button>',
                infinite: true,
                slidesToShow: slidesMobile,
                slidesToScroll: slidesScrollMobile,
                autoplay: autoplayMobile,
                autoplaySpeed: autoplaySpeedMobile * 1000,
                swipeToSlide: true,
                waitForAnimate: true
            };

            slickConfig = stopInfiniteLoop($moduleCarousel, slickConfig);
            $carousel.slick(slickConfig);
        }
    });
}

/**
 * Module Carousel 1-8 Desktop
 */
function desktopCarousel1To8() {
    $('.experience-moduleCarousel1To8 .experience-region').each(function () {
        var $carousel = $(this);
        var $container = $carousel.closest('.carousel-container');
        var $moduleCarousel = $carousel.closest('.experience-moduleCarousel1To8');
        var toggleCarousel = $carousel.attr('data-slides-togglecarousel') === 'true';
        var sidePaddingDesktop = $carousel.attr('data-side-padding-desktop') !== 'false';

        $carousel.removeClass('carousel-mobile-grid');
        $carousel.children('.experience-component').css({ flex: '', 'max-width': '' });

        if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
        }

        var slidesDesktop = parseInt($carousel.attr('data-slides-desktop'), 10) || 8;
        var slidesScrollDesktop = parseInt($carousel.attr('data-slides-scrolldesktop'), 10) || 1;
        var slidesMobileRaw = parseFloat($carousel.attr('data-slides-mobile')) || 1.2;
        var slidesMobile = Math.floor(slidesMobileRaw);
        var slidesScrollMobile = parseInt($carousel.attr('data-slides-scrollmobile'), 10) || 1;
        var paginationDesktop = $carousel.attr('data-slides-paginationdesktop') === 'true';
        var paginationMobile = $carousel.attr('data-slides-paginationmobile') === 'true';
        var arrowsDesktop = $carousel.attr('data-slides-arrowsdesktop') === 'true';
        var arrowsMobile = $carousel.attr('data-slides-arrowsmobile') === 'true';
        var autoplayDesktop = $carousel.attr('data-slides-autoplaydesktop') === 'true';
        var autoplayMobile = $carousel.attr('data-slides-autoplaymobile') === 'true';
        var autoplaySpeedDesktop = parseInt($carousel.attr('data-autoplay-speed-desktop'), 10) || 2;
        var autoplaySpeedMobile = parseInt($carousel.attr('data-autoplay-speed-mobile'), 10) || 2;

        var slickConfig = toggleCarousel ? {
            mobileFirst: true,
            dots: paginationMobile,
            arrows: arrowsMobile,
            prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span></button>',
            infinite: true,
            slidesToShow: slidesMobile,
            slidesToScroll: slidesScrollMobile,
            autoplay: autoplayMobile,
            autoplaySpeed: autoplaySpeedMobile * 1000,
            swipeToSlide: true,
            waitForAnimate: true,
            responsive: [{
                breakpoint: 991,
                settings: 'unslick'
            }]
        } : {
            dots: paginationDesktop,
            arrows: arrowsDesktop,
            prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span></button>',
            infinite: true,
            slidesToShow: slidesDesktop,
            slidesToScroll: slidesScrollDesktop,
            autoplay: autoplayDesktop,
            autoplaySpeed: autoplaySpeedDesktop * 1000,
            waitForAnimate: true,
            responsive: [{
                breakpoint: 992,
                settings: {
                    dots: paginationMobile,
                    arrows: arrowsMobile,
                    slidesToShow: slidesMobile,
                    slidesToScroll: slidesScrollMobile,
                    autoplay: autoplayMobile,
                    autoplaySpeed: autoplaySpeedMobile * 1000,
                    swipeToSlide: true,
                    waitForAnimate: true
                }
            }]
        };

        slickConfig = stopInfiniteLoop($moduleCarousel, slickConfig);

        if (!toggleCarousel && sidePaddingDesktop) {
            $container.addClass('has-side-padding');
        }

        $carousel.slick(slickConfig);
    });
}

var toggleCarouselsBool;

/**
 * Toggle Carousels: T5 / TCatAB / TCatDE / TCatE
 */
function toggleCarousels() {
    if (utils.mediaBreakpointDown('sm')) {
        if (!toggleCarouselsBool) {
            buildMobileModule5View();
            mobileCarouselModule10();
            mobileCarouselModule12();
            groupModule16Tiles();
            mobileCarouselTCatAB();
            mobileCarouselTCatDE();
            mobileCarouselTCatE();
            mobileCarouselImagesGrid();
            mobileCarousel1To8();
            toggleCarouselsBool = true;
        }
    } else if (!utils.mediaBreakpointDown('sm')) {
        if (toggleCarouselsBool || toggleCarouselsBool === undefined) {
            buildDesktopModule5View();
            desktopCarouselModule10();
            unGroupModule16Tiles();
            desktopCarouselTCatAB();
            desktopCarouselTCatDE();
            desktopCarouselTCatE();
            mobileCarouselImagesGrid();
            desktopCarouselModule12();
            desktopCarousel1To8();
            toggleCarouselsBool = false;
        }
    }
}

/**
 * To be used when a Slick carousel is configured with 'variableWidth: true' and centerMode/infinite to false.
 * Adjusts slidesToShow based on the slides being fully visible on the viewport to properly show/hide the arrows when needed.
 * @param {*} slick slick instance
 */
// function variableWidthCarouselArrows(slick) {
//     slick.$slides.each(function (index) { // eslint-disable-line
//         var sliderNumber = index + 1; // Need to be 1 based;
//         var isFullyVisible = (slick.$slider[0].clientWidth >= this.offsetLeft + this.clientWidth);

//         if (!isFullyVisible) {
//             slick.$slider.slick('slickSetOption', 'slidesToShow', index, true);
//             return false;
//         } else if (sliderNumber === slick.slideCount) {
//             slick.$slider.slick('slickSetOption', 'slidesToShow', slick.slideCount, true);
//         }
//     });
// }

module.exports = function () {
    $('.mobileGridViewBtn').on('click', function () {
        var parent = $(this).parent();
        var carousel = parent.prev('.experience-tileCarousel_E, .experience-region');
        carousel.removeClass('carousel-mobile-grid');
        parent.addClass('d-none');
    });

    $('.experience-modules_layouts-module1Layout').each(function () {
        if ($(this).find('.experience-slides.carousel-active').length) {
            var slickConfig = SLICK_SETTINGS.module1;
            slickConfig = appendAutoplaySettings($(this), slickConfig);
            slickConfig = stopInfiniteLoop($(this), slickConfig);
            slickConfig = appendInstantSwitch($(this), slickConfig);
            slickConfig = appendSpeedSettings($(this), slickConfig);
            slickConfig = appendToggleArrow($(this), slickConfig);
            slickConfig = appendPagination($(this), slickConfig);
            slickConfig = appendPauseOnHover($(this), slickConfig);
            $(this).find('.experience-slides.carousel-active').slick(slickConfig);
        }
    });

    $('.experience-modules_layouts-module2Layout').each(function () {
        if ($(this).find('.carousel-active').length) {
            var slickConfig = SLICK_SETTINGS.module2;
            slickConfig = appendAutoplaySettings($(this), slickConfig);
            slickConfig = appendSpeedSettings($(this), slickConfig);
            slickConfig = appendToggleArrow($(this), slickConfig);
            slickConfig = appendPauseOnHover($(this), slickConfig);
            $(this).find('.experience-tilesT2_1.carousel-active').slick(slickConfig);
            $(this).find('.experience-tilesT2_2.carousel-active').slick(slickConfig);
            $(this).find('.experience-tilesT2_3.carousel-active').slick(slickConfig);
        }
    });

    $('.experience-modules_layouts-module7Layout').each(function () {
        if ($(this).find('.experience-tileCarousel_7.carousel-active').length) {
            var slickConfig = SLICK_SETTINGS.module7;
            slickConfig = appendAutoplaySettings($(this), slickConfig);
            slickConfig = stopInfiniteLoop($(this), slickConfig);
            slickConfig = appendInstantSwitch($(this), slickConfig);
            slickConfig = appendSpeedSettings($(this), slickConfig);
            slickConfig = appendToggleArrow($(this), slickConfig);
            slickConfig = appendPauseOnHover($(this), slickConfig);
            $(this).find('.experience-tileCarousel_7.carousel-active').slick(slickConfig);
        }
    });

    $('.experience-modules_layouts-module10BLayout').each(function () {
        if ($(this).find('.experience-mediaMain.carousel-active').length) {
            var slickConfig = SLICK_SETTINGS.module1;
            slickConfig = appendAutoplaySettings($(this), slickConfig);
            slickConfig = stopInfiniteLoop($(this), slickConfig);
            slickConfig = appendInstantSwitch($(this), slickConfig);
            slickConfig = appendToggleArrow($(this), slickConfig);
            slickConfig = appendPauseOnHover($(this), slickConfig);
            $(this).find('.experience-mediaMain.carousel-active').slick(slickConfig);
        }
    });

    $('.experience-modules_layouts-module15Layout').each(function () {
        if ($(this).find('.carousel-active').length) {
            var slickConfig = SLICK_SETTINGS.module15;
            slickConfig = appendAutoplaySettings($(this), slickConfig);
            slickConfig = stopInfiniteLoop($(this), slickConfig);
            slickConfig = appendInstantSwitch($(this), slickConfig);
            slickConfig = appendSpeedSettings($(this), slickConfig);
            slickConfig = appendToggleArrow($(this), slickConfig);
            slickConfig = appendPauseOnHover($(this), slickConfig);
            $(this).find('.experience-tiles1_15.carousel-active').slick(slickConfig);
            $(this).find('.experience-tiles2_15.carousel-active').slick(slickConfig);
        }
    });

    $('.experience-modules_layouts-module17Layout').each(function () {
        var slickConfig = SLICK_SETTINGS.module17;
        slickConfig = appendAutoplaySettings($(this), slickConfig);
        slickConfig = appendScrollRow($(this), slickConfig);
        slickConfig = appendSpeedSettings($(this), slickConfig);
        slickConfig = appendToggleArrow($(this), slickConfig);
        slickConfig = appendPauseOnHover($(this), slickConfig);
        $(this).find('.experience-tiles_17').slick(slickConfig);
    });

    $('.experience-modules_layouts-module18Layout').each(function () {
        if ($(this).find('.experience-tiles1_18.carousel-active').length) {
            var slickConfig = SLICK_SETTINGS.module18;
            slickConfig = appendAutoplaySettings($(this), slickConfig);
            slickConfig = stopInfiniteLoop($(this), slickConfig);
            slickConfig = appendSpeedSettings($(this), slickConfig);
            slickConfig = appendInstantSwitch($(this), slickConfig);
            slickConfig = appendToggleArrow($(this), slickConfig);
            slickConfig = appendPauseOnHover($(this), slickConfig);
            $(this).find('.experience-tiles1_18.carousel-active').slick(slickConfig);
        }
    });

    $('.experience-modules_assets-module20Tile .experience-module_tile.has-carousel').each(function () {
        $(this).parent().addClass('carousel-parent');
        var carouselAutoplay = $(this).data('carousel-autoplay');
        var carouselDesktopSpeed = $(this).data('carousel-desktopspeed');
        var carouselMobileSpeed = $(this).data('carousel-mobilespeed');
        var carouselAnimationSpeed = $(this).data('carousel-animationspeed');

        $(this).not('.slick-initialized').slick({
            autoplay: carouselAutoplay,
            infinite: false,
            autoplaySpeed: carouselDesktopSpeed,
            speed: carouselAnimationSpeed,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        autoplay: carouselAutoplay,
                        infinite: false,
                        autoplaySpeed: carouselMobileSpeed,
                        speed: carouselAnimationSpeed
                    }
                }
            ]
        });
    });

    $('.experience-modules_layouts-mayWeSuggestManual').each(function () {
        var slickConfig = SLICK_SETTINGS.moduleMayWeSuggest;
        slickConfig = appendAutoplaySettings($(this), slickConfig);
        $(this).find('.experience-product_tiles').slick(slickConfig);
    });

    $('.experience-moduleCarousel1To8 .experience-region').not('.slick-initialized').each(function () {
        var $carousel = $(this);
        var $container = $carousel.closest('.carousel-container');
        var $moduleCarousel = $carousel.closest('.experience-moduleCarousel1To8');
        var slidesDesktop = parseInt($carousel.attr('data-slides-desktop'), 10) || 8;
        var slidesScrollDesktop = parseInt($carousel.attr('data-slides-scrolldesktop'), 10) || 1;
        var slidesMobileRaw = parseFloat($carousel.attr('data-slides-mobile')) || 1.2;
        var slidesMobile = Math.floor(slidesMobileRaw);
        var slidesScrollMobile = parseInt($carousel.attr('data-slides-scrollmobile'), 10) || 1;
        var toggleCarousel = $carousel.attr('data-slides-togglecarousel') === 'true';
        var gridViewMobile = $carousel.attr('data-slides-gridviewmobile') === 'true';
        var gridColumns = parseInt($carousel.attr('data-slides-gridcolumns'), 10) || 2;
        var paginationDesktop = $carousel.attr('data-slides-paginationdesktop') === 'true';
        var paginationMobile = $carousel.attr('data-slides-paginationmobile') === 'true';
        var arrowsDesktop = $carousel.attr('data-slides-arrowsdesktop') === 'true';
        var arrowsMobile = $carousel.attr('data-slides-arrowsmobile') === 'true';
        var autoplayDesktop = $carousel.attr('data-slides-autoplaydesktop') === 'true';
        var autoplayMobile = $carousel.attr('data-slides-autoplaymobile') === 'true';
        var autoplaySpeedDesktop = parseInt($carousel.attr('data-autoplay-speed-desktop'), 10) || 2;
        var autoplaySpeedMobile = parseInt($carousel.attr('data-autoplay-speed-mobile'), 10) || 2;
        var sidePaddingDesktop = $carousel.attr('data-side-padding-desktop') !== 'false';

        if (gridViewMobile) {
            $carousel.addClass('carousel-mobile-grid');
            var slidesCount = $carousel.children().length;
            if (slidesCount > 8) {
                $carousel.next('.mobileGridViewBtn-wrapper').removeClass('d-none');
            }
            return;
        }

        var slickConfig = toggleCarousel ? {
            mobileFirst: true,
            dots: paginationMobile,
            arrows: arrowsMobile,
            infinite: true,
            slidesToShow: slidesMobile,
            slidesToScroll: slidesScrollMobile,
            autoplay: autoplayMobile,
            autoplaySpeed: autoplaySpeedMobile * 1000,
            swipeToSlide: true,
            waitForAnimate: true,
            customPaging: customPaging,
            responsive: [{
                breakpoint: 991,
                settings: 'unslick'
            }]
        } : {
            dots: paginationDesktop,
            arrows: arrowsDesktop,
            infinite: true,
            slidesToShow: slidesDesktop,
            slidesToScroll: slidesScrollDesktop,
            autoplay: autoplayDesktop,
            autoplaySpeed: autoplaySpeedDesktop * 1000,
            waitForAnimate: true,
            customPaging: customPaging,
            responsive: [{
                breakpoint: 992,
                settings: {
                    dots: paginationMobile,
                    arrows: arrowsMobile,
                    slidesToShow: slidesMobile,
                    slidesToScroll: slidesScrollMobile,
                    autoplay: autoplayMobile,
                    autoplaySpeed: autoplaySpeedMobile * 1000,
                    swipeToSlide: true,
                    waitForAnimate: true
                }
            }]
        };

        slickConfig = stopInfiniteLoop($moduleCarousel, slickConfig);

        if (!toggleCarousel && sidePaddingDesktop) {
            $container.addClass('has-side-padding');
        }

        $carousel.slick(slickConfig);
    });

    $('.slick-slider').on('touchend', function () {
        var autoPlay = $(this).closest('.experience-component').find($('.carousel-autoplay'));
        if (autoPlay.length > 0) {
            $(this).slick('slickPlay');
        }
    });

    utils.smartResize(function () {
        toggleCarousels();
    });

    toggleCarousels();
};
